var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"shake"}},[(_vm.errors[0])?_c('div',{staticClass:"text-danger"},[_vm._v("\n    "+_vm._s(_vm.errors[0])+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }